import { render } from "./ModalItemModifierOption.vue?vue&type=template&id=05d7b8b8&scoped=true"
import script from "./ModalItemModifierOption.vue?vue&type=script&lang=js"
export * from "./ModalItemModifierOption.vue?vue&type=script&lang=js"

import "./ModalItemModifierOption.vue?vue&type=style&index=0&id=05d7b8b8&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d7b8b8"]])

export default __exports__